<template>
	<card title="Conditions">
		<div class="sk-group" v-if="hasData">
			<div class="sk-group-list" v-for="item in collection" :key="item.id">
				<div class="sk-group-list-item">
					<div class="sk-group-list-item-value">
						<span>{{ getDiseaseNameById(item.name_id).name }}</span>
						<span class="sk-group-list-item-label">{{ item.comments }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
		<template v-slot:more-options>
			<card-option-item-link route="WatchProfileMedicalInformation" :args="{ watch_id: patient.id }" :title="$t('See More')" />
		</template>
	</card>
</template>

<script>
import CardOptionItemLink from '@/modules/common/CardOptionItemLink'
import { mapGetters } from 'vuex'
import Card from '@/modules/common/Card'
export default {
	name: 'card-pacient-diseases',
	components: {
		Card,
		CardOptionItemLink
	},
	props: {
		patient: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			collection: []
		}
	},
	computed: {
		hasData: function() {
			return this.collection.length > 0
		},
		...mapGetters({
			getCollection: 'PATIENTS_DISEASES',
			getDiseaseNameById: 'DISEASE_NAME_BY_ID',
		}),
	},
	methods: {
	},
	created() {
		this.collection = this.getCollection(this.patient)
	}
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientDiseases.vue